<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div
      v-if="showCarousel"
      class="automated-carousel"
      :class="{'carousel-editor': isEditMode}"
    >
      <ImageCarousel :theme="themeColor">
        <template #title>
          <sc-clickable
            class="automated-carousel__heading"
            :href="landingUrl"
          >
            <sh-heading
              type="h2"
              size-desktop="size-5"
              size-mobile="size-5"
            >
              {{ carouselTitle }}
            </sh-heading>
          </sc-clickable>
        </template>
        <template>
          <template v-if="tiles">
            <AutomatedCarouselTile
              v-for="tile in tiles"
              :key="tile.source.value"
              :fields="tile"
            />
          </template>
          <div v-else />
        </template>
      </ImageCarousel>
    </div>
  </sc-render>
</template>

<script>

import { ImageCarousel, Heading } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'

import mapFields from '~/helpers/map-fields'

import ScRender from '~/components/sitecore/sc-render'
import AutomatedCarouselTile from '~/components/sitecore/automated-carousel-tile'
import ScClickable from '~/components/sitecore/sc-clickable'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'AutomatedCarousel',

  components: {
    ScClickable,
    ShHeading: Heading,
    ImageCarousel,
    ScRender,
    AutomatedCarouselTile
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['themeColor']),
    ...mapFields({
      carouselTitle: 'carouselTitle.value',
      tiles: 'carouselItems',
      landingUrl: 'landingUrl.value'
    }),

    showCarousel () {
      return this.isEditMode || this.tiles
    }
  }
}
</script>

<style lang="scss" scoped>

.automated-carousel {
  max-width: 100%;
  margin: $space-090 0;

  @include tablet() {
    margin: $space-110 0;
  }

  &__heading {
    text-decoration: none;
  }
}

.carousel-editor {
  width: 100%;
  display: flex;
  overflow-x: scroll;

  // to avoid extra carousel spaces in EE
  > div {
    margin: 0;
  }
}

</style>
